"use client";

import { LngLatLike } from "maplibre-gl";
import { useMap } from "maplibre-react-components";
import { useTranslations } from "next-intl";
import React, { type ReactElement } from "react";
import { toast } from "sonner";
import { Place } from "@/types";

interface SitesRegionSearchResultProps {
  results: Place[];
}

function SitesRegionSearchResult({
  results,
}: Readonly<SitesRegionSearchResultProps>): ReactElement | null {
  const t = useTranslations("sites.RegionSearchResult");
  const map = useMap("map");

  const handleClick = (place: Place): void => {
    if (map && place.lon && place.lat) {
      const point: LngLatLike = [Number(place.lon), Number(place.lat)];
      map.flyTo({ center: point, zoom: 10 });
    } else {
      toast(t("error.title"), {
        description: t("error.description"),
      });
    }
  };

  if (results.length > 0) {
    return (
      <ul className="list-none p-1.5 m-0 flex-flex-col gap-1 max-h-96 overflow-y-auto">
        {results.map((place) => (
          <li
            className="p-1 rounded text-xs leading-tight hover:cursor-pointer hover:bg-accent"
            key={place.place_id}
          >
            <button
              onClick={() => {
                handleClick(place);
              }}
            >
              {place.display_name}{" "}
              <em className="text-muted-foreground capitalize not-italic">
                {place.addresstype}
              </em>
            </button>
          </li>
        ))}
      </ul>
    );
  }

  return null;
}

export { SitesRegionSearchResult, type SitesRegionSearchResultProps };
